import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from 'axios';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography'
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

import StandaloneRequestDetails from '../common/standalone/standalone-request-details';
import RequestPreview from '../common/request/request-preview';
import RequestDetailsSkeleton from '../common/skeleton/request-details-skeleton';
import RequestInfoSkeleton from '../common/skeleton/request-info-skeleton';
import OfferInfo from '../common/offer-info';
import { Panel, PanelHeader, PanelContent } from '../common/panel';

import { renderAttachment } from '../../../helpers/attachment-helper';
import { checkTokenExpirationMiddleware } from '../../../middlewares/users-auth.middleware';

const StandaloneOffer = () => {
    const [user] = useState(checkTokenExpirationMiddleware());
    const [loading, setLoading] = useState({
        skeleton: true,
        backdrop: false
    });
    const [standaloneOffer, setStandaloneOffer] = useState(null);
    const [, setError] = useState(null);
    const { id } = useParams();
    let history = useHistory();

    let headers = {
        "Authorization": `Bearer ${user.Token}`
    };

    useEffect(() => {
        axios.get(`/api/standaloneoffer/${id}`, { headers: headers })
            .then(res => {
                setStandaloneOffer(res.data);
                setTimeout(() => setLoading({ ...loading, skeleton: false }), 500);
            })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }, [])

    const deleteOffer = () => {
        setLoading({ ...loading, backdrop: true });
        axios.delete(`/api/standaloneoffer/${id}`, { headers: headers })
            .then(res => {
                setTimeout(() => history.push(`/request/${standaloneOffer.reservationReqId}/standalone`), 500);

            })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }

    return (
        <>
            {
                loading.backdrop ?
                    <Backdrop className="backdrop" open={loading.backdrop}>
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    :
                    null
            }
            <Grid container spacing={3}>
                <Grid
                    container item xs={12} md={12} lg={9}
                >
                    <Panel>
                        <PanelHeader>Request Details</PanelHeader>
                        <PanelContent>
                            {loading.skeleton ?
                                <RequestDetailsSkeleton />
                                :
                                standaloneOffer ?
                                    <>
                                        <RequestPreview
                                            label={"Standalone"}
                                            reservationRequest={standaloneOffer.reservationRequestStandaloneResource}
                                            Details={
                                                <StandaloneRequestDetails
                                                    reservationRequest={standaloneOffer.reservationRequestStandaloneResource}
                                                />
                                            }
                                        />
                                    </>
                                    : null
                            }
                        </PanelContent>
                    </Panel>

                    <Panel>
                        <PanelHeader>Offer Details</PanelHeader>
                        <PanelContent>
                            {loading.skeleton ?
                                <RequestDetailsSkeleton />
                                :
                                standaloneOffer ?
                                    <>
                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Categories Offers:
                                            </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    {
                                                        standaloneOffer.reservationSupFlightOfferId ?
                                                            <>
                                                                Flight: 
                                                                <i>
                                                                    <a
                                                                        rel="noopener noreferrer"
                                                                        href={`/offer/flight/${standaloneOffer.reservationSupFlightOfferId}`}
                                                                        target="_blank"
                                                                        style={{ color: `#485dd4` }}
                                                                    >{standaloneOffer.flightOfferHeadline}</a>
                                                                </i> <br />
                                                            </> : null
                                                    }
                                                    {
                                                        standaloneOffer.reservationSupVisaOfferId ?
                                                            <>
                                                                Visa:
                                                                <i>
                                                                    <a
                                                                        rel="noopener noreferrer"
                                                                        href={`/offer/visa/${standaloneOffer.reservationSupVisaOfferId}`}
                                                                        target="_blank"
                                                                        style={{ color: `#485dd4` }}
                                                                    >{standaloneOffer.visaOfferHeadline}</a>
                                                                </i> <br />
                                                            </> : null
                                                    }
                                                    {
                                                        standaloneOffer.reservationSupHotelOfferId ?
                                                            <>
                                                                Hotel:
                                                                <i>
                                                                    <a
                                                                        rel="noopener noreferrer"
                                                                        href={`/offer/hotel/${standaloneOffer.reservationSupHotelOfferId}`}
                                                                        target="_blank"
                                                                        style={{ color: `#485dd4` }}
                                                                    >{standaloneOffer.hotelOfferHeadline}</a>
                                                                </i> <br />
                                                            </> : null
                                                    }
                                                    {
                                                        standaloneOffer.reservationSupRegistrationOfferId ?
                                                            <>
                                                                Registration:
                                                                <i>
                                                                    <a
                                                                        rel="noopener noreferrer"
                                                                        href={`/offer/registration/${standaloneOffer.reservationSupRegistrationOfferId}`}
                                                                        target="_blank"
                                                                        style={{ color: `#485dd4` }}
                                                                    >{standaloneOffer.registrationOfferHeadline}</a>
                                                                </i> <br />
                                                            </> : null
                                                    }
                                                    {
                                                        standaloneOffer.reservationSupTransportationOfferId ?
                                                            <>
                                                                Transportation:
                                                                <i>
                                                                    <a
                                                                        rel="noopener noreferrer"
                                                                        href={`/offer/transportation/${standaloneOffer.reservationSupTransportationOfferId}`}
                                                                        target="_blank"
                                                                        style={{ color: `#485dd4` }}
                                                                    >{standaloneOffer.transportationOfferHeadline}</a>
                                                                </i> <br />
                                                            </> : null
                                                    }
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Price:
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    {standaloneOffer.noofAdults} Adults ({standaloneOffer.adultPackagePriceInSingle}  L.E. Per Adult SGL)
                                                    ({standaloneOffer.adultPackagePriceInDouble}  L.E. Per Adult DBL)
                                                    <br />
                                                    {standaloneOffer.noofChilds ?
                                                        <>{`${standaloneOffer.noofChilds} Childs (${standaloneOffer.childPrice} L.E. Per Child)`} <br /></> : null}
                                                    {standaloneOffer.noofInfants ?
                                                        `${standaloneOffer.noofInfants} Infants (${standaloneOffer.infantPrice} L.E. Per Infant)` : null}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Inclusions:
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography className="pre-wrap" variant="subtitle1" gutterBottom>
                                                    {
                                                        standaloneOffer.reservationSupplierStandaloneOfferInclusionResources.map((inclusion, index) => (
                                                            <span key={index}>&#9658;{inclusion.inclusionDescription}</span>
                                                        ))
                                                    }
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Inclusions Notes:
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography className="pre-wrap" variant="subtitle1" gutterBottom>
                                                    {standaloneOffer.inclusionsNotes}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Payment Policy:
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography className="pre-wrap" variant="subtitle1" gutterBottom>
                                                    {standaloneOffer.paymentPolicy}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Cancellation Policy:
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography className="pre-wrap" variant="subtitle1" gutterBottom>
                                                    {standaloneOffer.cancellationPolicy}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Free Policy:
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography className="pre-wrap" variant="subtitle1" gutterBottom>
                                                    {standaloneOffer.freePolicy}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Exclusions Notes:
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography className="pre-wrap" variant="subtitle1" gutterBottom>
                                                    {standaloneOffer.exclusionsNotes}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        <Grid container item xs={12}>
                                            <Grid item xs={3}>
                                                <Typography variant="button" gutterBottom>
                                                    Attachment:
                                            </Typography>
                                            </Grid>
                                            <Grid item xs={9}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    {renderAttachment(standaloneOffer.attachment)}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </>
                                    : null
                            }
                        </PanelContent>
                    </Panel>
                </Grid>

                <Grid
                    container item xs={12} md={12} lg={3}
                >
                    <div className="side-info">
                        {
                            loading.skeleton ?
                                <RequestInfoSkeleton />
                                :
                                standaloneOffer ?
                                    <OfferInfo offer={standaloneOffer} deleteOffer={deleteOffer} />
                                    : null
                        }
                    </div>
                </Grid>
            </Grid>
        </>
    );
}

export default StandaloneOffer;